module.exports = __webpack_public_path__ + "img/credit_buy_modal_icon.10c6d553.svg";